import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehiclesTrackerStateIconsSelectorComponent } from './vehicles-tracker-state-icons-selector.component';
import {DxButtonModule, DxLoadPanelModule, DxPopupModule} from 'devextreme-angular';
import { VehiclesTrackerStateIconComponent } from './vehicles-tracker-state-icon/vehicles-tracker-state-icon.component';



@NgModule({
  declarations: [VehiclesTrackerStateIconsSelectorComponent, VehiclesTrackerStateIconComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    DxButtonModule,
    DxLoadPanelModule
  ],
  exports: [VehiclesTrackerStateIconsSelectorComponent]
})
export class VehiclesTrackerStateIconsSelectorModule { }
